import { render, staticRenderFns } from "./SingleEstate.vue?vue&type=template&id=9fd0e542&scoped=true&"
import script from "./SingleEstate.vue?vue&type=script&lang=js&"
export * from "./SingleEstate.vue?vue&type=script&lang=js&"
import style0 from "./SingleEstate.vue?vue&type=style&index=0&id=9fd0e542&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fd0e542",
  null
  
)

export default component.exports